/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForNagios extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForNagios");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForNagios.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForNagios>): ServiceAccountNativeDetailsForNagios {
        let obj = Object.assign(new ServiceAccountNativeDetailsForNagios(), model);
        ServiceAccountNativeDetailsForNagios.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForNagios>): ServiceAccountNativeDetailsForNagios {
        if (!model) return null;
        return ServiceAccountNativeDetailsForNagios.newInstance(<ServiceAccountNativeDetailsForNagios> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForNagios) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForNagios.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForNagios): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForNagios.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
